import Details from '../partyDetails/details';
import Address from '../partyDetails/address';
import Bank from '../partyDetails/bank';
import Contact from '../partyDetails/contact';
import Compliance from '../partyDetails/compliance';
import Additional from '../partyDetails/additional';
import Documents from '../partyDetails/allDocuments';
import Evaluation from '../partyDetails/evaluation';
import AccountingDetails from './accountingDetails';
import VendorCategory from '../partyDetails/vendorCategory';
export default {
  name: 'PartyDetail',
  components: {
    Details,
    Address,
    Bank,
    Contact,
    Compliance,
    Documents,
    Additional,
    Evaluation,
    AccountingDetails,
    VendorCategory
  },
  props: [
    'partyRowDetails',
    'wfMenuId',
    'userId',
    'eventId',
    'dashboardDetails'
  ],
  data() {
    return {
      loader: false,
      activeTab: 'Details',
      urlSummaryData: null,
      menuId: null,
      workflowId: { menuId: null, userId: null, eventId: null },
      templateTypeProp: null
    };
  },
  created() {
    this.userId = this.$store.state.auth.userId;
    if (this.$route.params.summaryData) {
      this.urlSummaryData = JSON.parse(
        Buffer.from(this.$route.params.summaryData, 'base64').toString('ascii')
      );
      this.menuId = this.urlSummaryData.wf_menu_id;
    } else {
      this.menuId = this.wfMenuId;
    }
    this.workflowId.menuId = this.wfMenuId;
    this.workflowId.userId = this.userId;
    this.workflowId.eventId = this.eventId;
  },
  methods: {
    templateTypeRecieve(result) {
      this.templateTypeProp = result;
    },
    selectedTab(tab) {
      this.activeTab = tab;
    },
    updatedDetails() {
      this.$emit('gridDetailsUpdated');
    },
    updatedAddress() {
      this.$emit('gridAddressUpdated');
    },
    updatedContact() {
      this.$emit('gridContactUpdated');
    },
    updatedBank() {
      this.$emit('gridBankUpdated');
    },
    updatedAccount() {
      this.$emit('gridAccUpdated');
    }
  }
};
